import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import Cookie from 'utils/cookies';
import Slider from 'react-slick';
import Link from 'components/Link';
import s from './GamesCardSlider.scss';
import GameCard from '../../../../../routes/games/components/common/GameCard/GameCard';
// import makeRequest from '../../../../../utils/makeRequest';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import {
  TOI_LIVE_DOMAIN,
  // UNIFIED_FEED_DOMAIN_SERVICE,
} from '../../../../../constants';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import Morebtn from '../../../../../components_v2/mobile/Morebtn';

const GamesCardSlider = ({ sectionData, isWapView }) => {
  // const [items, setItems] = useState([]);
  const ref = useRef(null);

  // const userDataRef = useRef(userData);

  // const getUserData = () => {
  //   try {
  //     const ssoId = Cookie.get('ssoid') || Cookie.get('ssoId') || '';
  //     const grxId = Cookie.get('_grx') || '';
  //     const GAMESLISTINGAPI = `/ufs-utility/toi-games/fetch/game/listing?pc=toi&pfm=web`;
  //     const requestParams = {
  //       params: {},
  //       headers: {
  //         grxId,
  //         ssoId,
  //       },
  //     };
  //     const mWebParam = isWapView ? '&isMobile=true' : '';
  //     const url = `${UNIFIED_FEED_DOMAIN_SERVICE}${GAMESLISTINGAPI}${mWebParam}`;
  //     makeRequest.get(url, requestParams, 'skipfeedengine').then(data => {
  //       if (data?.data?.items?.length > 0) {
  //         setItems(data?.data?.items);
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Failed to fetch game data', error);
  //   }
  // };

  // useEffect(
  //   () => {
  //     if (
  //       userData &&
  //       userData.isLoggedIn !== userDataRef?.current?.isLoggedIn
  //     ) {
  //       getUserData();
  //     }
  //     userDataRef.current = userData;
  //   },
  //   [userData],
  // );

  const convertStringBooleans = data => {
    if (Array.isArray(data)) {
      return data.map(convertStringBooleans);
    }
    if (typeof data === 'object' && data !== null) {
      // Convert all boolean-like string values to actual booleans
      const convertedData = Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
          key,
          typeof value === 'string' && (value === 'true' || value === 'false')
            ? value === 'true'
            : convertStringBooleans(value),
        ]),
      );
      // If `gameStatus` exists and is an object, convert it into an array
      if (
        convertedData.gameStatus &&
        typeof convertedData.gameStatus === 'object' &&
        !Array.isArray(convertedData.gameStatus)
      ) {
        convertedData.gameStatus = [convertedData.gameStatus];
      }
      return convertedData;
    }
    return data;
  };

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 3.3,
    slidesToScroll: 1,
    infinite: false,
  };

  if (!sectionData) return null;

  // const gamesListData =
  //   // eslint-disable-next-line no-nested-ternary
  //   items?.length > 0
  //     ? items
  //     : sectionData?.items?.length > 0
  //       ? convertStringBooleans(sectionData.items)
  //       : [];
  const gamesListData =
    sectionData?.items?.length > 0
      ? convertStringBooleans(sectionData.items)
      : [];
  // const calledFrom = items.length > 0 ? '' : 'ssr_homepage';
  const calledFrom = 'ssr_homepage';
  if (gamesListData?.length > 0 && Array.isArray(gamesListData)) {
    gamesListData.forEach(gameitem => {
      gameitem.gameCategoryConfigData = {};
      if (
        !gameitem.gameCategoryData ||
        typeof gameitem.gameCategoryData !== 'object'
      ) {
        gameitem.gameCategoryConfigData = {
          listingIconUrl: {
            finishImageUrl: '',
            imageUrl: '',
            pauseImageUrl: '',
          },
        };
      } else {
        const {
          // finishImageUrl,
          imageUrl,
          pauseImageUrl,
        } = gameitem.gameCategoryData;
        gameitem.gameCategoryConfigData = {
          listingIconUrl: {
            finishImageUrl: imageUrl?.trim() || '',
            imageUrl: imageUrl?.trim() || '',
            pauseImageUrl: pauseImageUrl?.trim() || imageUrl?.trim() || '',
          },
        };
      }
    });
  }

  return (
    <>
      <InViewObserver
        inViewCallback={() =>
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: sectionData?.ga4Type,
            // category: sectionData?.ga4Category,
            label: 'homepage',
          })
        }
      >
        {sectionData?.border === 'top' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
        <div className={`${s.vocCardWrap} slick_UI`}>
          {!isWapView ? (
            <>
              <div className={s.topTitle}>
                <i className={s.iconToiGames} />
                <div className={s.exploreLink}>
                  <Link
                    to={`${TOI_LIVE_DOMAIN}/games`}
                    onClick={() =>
                      analyticsWrapper('ga4', {
                        event: 'user_click',
                        type: 'explore_all_games',
                        category: sectionData?.ga4Type || '',
                        label: 'homepage',
                      })
                    }
                  >
                    Explore All Games
                  </Link>
                </div>
              </div>
              {gamesListData?.length > 0 &&
                Array.isArray(gamesListData) && (
                  <Slider {...settings} ref={ref}>
                    {gamesListData.map(
                      sectionItem =>
                        sectionItem?.tn === 'gameCategory' &&
                        sectionItem?.gameCategoryData?.gameType ? (
                          <GameCard
                            key={sectionItem?.gameCategoryData?.gameType.replace(
                              /_/g,
                              '-',
                            )}
                            calledFrom={calledFrom}
                            widgetUsedOn="homepage"
                            gameType={sectionItem?.gameCategoryData?.gameType.replace(
                              /_/g,
                              '-',
                            )}
                            isMobile={isWapView}
                            ga4Category={sectionData?.ga4Type}
                            data={sectionItem?.gameCategoryData}
                            gameCategoryConfigData={
                              sectionItem?.gameCategoryConfigData || {}
                            }
                          />
                        ) : null,
                    )}
                  </Slider>
                )}
            </>
          ) : (
            <>
              {gamesListData?.length > 0 &&
                Array.isArray(gamesListData) && (
                  <>
                    <div className={s.dottedLine}>
                      <div className={s.toiGameCapsule}>
                        <i className={s.iconToiGames} />
                      </div>
                    </div>
                    <div className={s.mobileScroll}>
                      {gamesListData.map(
                        sectionItem =>
                          sectionItem?.tn === 'gameCategory' &&
                          sectionItem?.gameCategoryData?.gameType ? (
                            <GameCard
                              key={sectionItem.gameCategoryData.gameType.replace(
                                /_/g,
                                '-',
                              )}
                              calledFrom={calledFrom}
                              widgetUsedOn="homepage"
                              gameType={sectionItem.gameCategoryData.gameType.replace(
                                /_/g,
                                '-',
                              )}
                              isMobile={isWapView}
                              ga4Category={sectionData?.ga4Type}
                              data={sectionItem.gameCategoryData}
                              gameCategoryConfigData={
                                sectionItem.gameCategoryConfigData || {}
                              }
                            />
                          ) : null,
                      )}
                    </div>
                    <Morebtn
                      moreLink={sectionData?.path || '/games'}
                      absoluteMoreText={
                        sectionData?.moreText || 'Explore All Games'
                      }
                      ga4Type="explore_all_games"
                      ga4Category={sectionData?.ga4Type || ''}
                      gaLabel="homepage"
                    />
                  </>
                )}
            </>
          )}
        </div>
        {sectionData?.border === 'bottom' && (
          <InterSectionBorder border={sectionData?.border} />
        )}
      </InViewObserver>
    </>
  );
};

const mapStateToProps = state => ({
  userData: state.login.userData,
});

GamesCardSlider.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    id: PropTypes.string,
    subSections: PropTypes.shape({ dataUrl: PropTypes.string }),
  }),
  isWapView: PropTypes.bool,
  userData: PropTypes.shape({}),
};

GamesCardSlider.defaultProps = {
  sectionData: {},
  isWapView: false,
  userData: {},
};

export default connect(mapStateToProps, null)(GamesCardSlider);
